<template>
  <div class="c-form">
      <div class="c-form__search-experiments" v-bind:class="{ 'is-loading': isLoading }">
          <p class="c-form__field">
              <input class="c-form__input c-form__input--search" type="search" :placeholder="placeholder" v-on:change="$emit('changed', $event.target.value)"/>
              <span class="c-form__search"></span>
          </p>
      </div>
  </div>
</template>

<script>
export default {
  name: 'Search',
  props: {
    placeholder: {
      type: String,
      required: true,
    },
    isLoading: {
      type: Boolean,
    },
  },
}
</script>
